import { msiRequest } from "../../../index";
import { ResultType } from "../../../types";
import qs from "qs";
//接口url枚举
enum StatisticalEnumApi {
  WareToolUsers_PAGE = "/WareToolUsers/page", //分页查询领用记录
  WareToolUsers_ADD = "/WareToolUsers/add", //增加工量具基础表
  WareToolUsers_EDIT = "/WareToolUsers/edit", //更新
  WareToolUsers_DELETE = "/WareToolUsers/delete", //删除
  WareToolUsers_DETAIL = "/WareToolUsers/detail" //详情
}
//工量具 --- 列表
export function getWareToolPage(data: any = {}) {
  return msiRequest.get<ResultType<any>>({
    url: `${StatisticalEnumApi.WareToolUsers_PAGE}?${qs.stringify(data)}`,
    data
  });
}

//工量具 -- 添加
export function addWareTool(data: any = {}) {
  return msiRequest.post<ResultType<any>>({
    url: StatisticalEnumApi.WareToolUsers_ADD,
    data
  });
}

//工量具 -- 编辑
export function editWareTool(data: any = {}) {
  return msiRequest.post<ResultType<any>>({
    url: StatisticalEnumApi.WareToolUsers_EDIT,
    data
  });
}

//工量具 -- 删除
export function deleteWareTool(data: { orderNo: string }) {
  return msiRequest.post<ResultType<any>>({
    url: StatisticalEnumApi.WareToolUsers_DELETE,
    data
  });
}

//工量具 -- 详情
export function detailWareTool(data: { orderNo: string }) {
  return msiRequest.post<ResultType<any>>({
    url: `StatisticalEnumApi.WareToolUsers_DETAIL?Id=${qs.stringify(data)}`,
    data
  });
}
